import { z } from 'zod';

/**
 * Validation schema for variant
 * Matches the server-side VariantFieldsSchema expectations
 */
export const variantSchema = z.object({
    name: z.string().min(1, 'Variant name is required'),
    description: z.string().optional(),
    sku: z.string().nullable(),
    imageUrl: z.string().nullish(),
    grams: z.number().nullable(),
    active: z.boolean(),
    default: z.boolean().optional(),
    price: z.number().nullable(),
    compareAtPrice: z.number().nullable(),
    prices: z.array(z.any()),
    inStock: z.boolean(),
    creditPrice: z.number().nullable().optional(),
});

export type VariantFormData = z.infer<typeof variantSchema>;

